<template>
  <div class="rakuAi">
    <iframe src="https://aitest.rakumart.com/intelligentImage" frameborder="0"
      style="width: 100%;height: 100%;"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.rakuAi {
  height: 100%;
}
</style>